import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./router/ProtectedRoute";
import Layout from "./components/layout/Layout";

import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Revenue from "./pages/Revenue";
import Funnel from "./pages/Funnel";
import Products from "./pages/Products";
import Hypotheses from "./pages/Hypotheses";
import Board from "./pages/Board";
import Segments from "./pages/Segments";
import Traffic from "./pages/Traffic";
import Tiktok from "./pages/Tiktok";
import Settings from "./pages/Settings";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Protected><Overview /></Protected>} />
        <Route path="/revenue" element={<Protected><Revenue /></Protected>} />
        <Route path="/funnel" element={<Protected><Funnel /></Protected>} />
        <Route path="/products" element={<Protected><Products /></Protected>} />
        <Route path="/hypotheses" element={<Protected><Hypotheses /></Protected>} />
        <Route path="/board" element={<Protected><Board /></Protected>} />
        <Route path="/segments" element={<Protected><Segments /></Protected>} />
        <Route path="/traffic" element={<Protected><Traffic /></Protected>} />
        <Route path="/tiktok" element={<Protected><Tiktok /></Protected>} />
        <Route path="/settings" element={<Protected><Settings /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
